import { render, staticRenderFns } from "./Employees.vue?vue&type=template&id=e95a32f6&scoped=true"
import script from "./Employees.vue?vue&type=script&lang=js"
export * from "./Employees.vue?vue&type=script&lang=js"
import style0 from "./Employees.vue?vue&type=style&index=0&id=e95a32f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e95a32f6",
  null
  
)

export default component.exports